import { render, staticRenderFns } from "./BomList.vue?vue&type=template&id=d512416c"
import script from "./BomList.vue?vue&type=script&lang=js"
export * from "./BomList.vue?vue&type=script&lang=js"
import style0 from "./BomList.vue?vue&type=style&index=0&id=d512416c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports